import './Banner.scss';


const Banner: React.FC = () => {
    
    return (
        <article className='banner'>
            <picture>
                <img src='../../images/banner_hp.jpg' alt='Stetoskop lekarski'></img>
            </picture>
        </article>
    )
}

export default Banner;